const uaStr = navigator.userAgent;
const regex = {
    chrome: /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9.]+)/,
    edg: /Edg\/([0-9._]+)/,
    safari: /Version\/([0-9._]+).*Safari/
};
const isWin = uaStr.includes('Windows NT');
const isMac = uaStr.includes('Mac OS X');
const isIOS = ([
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
    'iOS'
].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (uaStr.includes('Mac') && 'ontouchend' in document));
const isSafari = regex.safari.test(uaStr);
const isChrome = regex.chrome.test(uaStr);
const isEdg = regex.edg.test(uaStr);
const version = (function () {
    function getVersion(reg) {
        var _a;
        return Number((_a = reg.exec(uaStr)) === null || _a === void 0 ? void 0 : _a[1].split('.')[0]);
    }
    if (isChrome) {
        return getVersion(regex.chrome);
    }
    else if (isEdg) {
        return getVersion(regex.edg);
    }
    else if (isSafari) {
        return getVersion(regex.safari);
    }
    return 0;
})();
export default {
    isWin() {
        return isWin;
    },
    isMac() {
        return isMac;
    },
    isIOS() {
        return isIOS;
    },
    isSafari() {
        return isSafari;
    },
    isChrome() {
        return isChrome;
    },
    /**
     * 是否新版（Chromium内核） Edge
     */
    isEdg() {
        return isEdg;
    },
    version() {
        return version;
    }
};
//# sourceMappingURL=ua.js.map